<template>
	<v-dialog
		v-model="exibirModalDesentranhamento"
		fullscreen
		scrollable
		persistent
		transition="dialog-bottom-transition"
	>
		<modal-confirmacao
			:titulo-modal="tituloModal"
			:exibir="exibirModalConfirmacao"
			:mensagem="mensagemConfirmacaoModal"
			@confirmar="tratarEventoConfirmarAcaoModal"
			@fechar-modal="tratarEventoCancelarAcaoModal"
		>
		</modal-confirmacao>
		<v-stepper :value="passoAtual.numero" class="container-desentranhamento">
			<v-stepper-header class="elevation-0 primary" style="max-height: 64px">
				<v-col
					id="acaoVoltar"
					class="coluna-desentranhamento arp-col"
					md="3"
					sm="6"
					cols="12"
					@click="tratarEventoVoltar"
				>
					<v-list-item two-line class="acao-voltar-desentranhar">
						<v-list-item-content id="acaoVoltar">
							<v-list-item-title class="label-desentranhamento">
								<v-icon size="16" color="white">mdi-arrow-left</v-icon>
								Voltar
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-col>

				<v-col
					v-if="!passoJuntadaTermoEstaCompleto"
					id="documentoAhDesentranhar"
					class="coluna-desentranhamento arp-col"
					md="2"
					sm="6"
					cols="12"
				>
					<v-list-item two-line>
						<v-list-item-content>
							<v-list-item-title class="label-desentranhamento"
								>Documento a desentranhar
							</v-list-item-title>
							<v-list-item-subtitle class="text-desentranhamento">
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span v-bind="attrs" v-on="on">
											<span>{{ documentoAhDesentranhar.titulo }}</span>
										</span>
									</template>
									<span>{{ documentoAhDesentranhar.titulo }}</span>
								</v-tooltip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</v-col>

				<v-spacer></v-spacer>

				<v-stepper-step
					:key="`${passos[0].numero}-header`"
					color="white"
					:complete="passos[0].completo"
					:step="passos[0].numero"
					:editable="!passos[0].desabilitado"
					edit-icon="mdi-check"
					class="label-desentranhamento"
					@click="tratarEventoPassoSelecionado(passos[0])"
				>
					{{ passos[0].titulo }}
				</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step
					:key="`${passos[1].numero}-header`"
					color="white"
					:complete="passos[1].completo"
					:step="passos[1].numero"
					:editable="!passos[1].desabilitado"
					edit-icon="mdi-check"
					class="label-desentranhamento"
					@click="tratarEventoPassoSelecionado(passos[1])"
				>
					{{ passos[1].titulo }}
				</v-stepper-step>

				<v-divider></v-divider>

				<v-stepper-step
					:key="`${passos[2].numero}-header`"
					color="white"
					:complete="passos[2].completo"
					:step="passos[2].numero"
					:editable="!passos[2].desabilitado"
					edit-icon="mdi-check"
					class="label-desentranhamento"
					@click="tratarEventoPassoSelecionado(passos[2])"
				>
					{{ passos[2].titulo }}
				</v-stepper-step>

				<v-spacer></v-spacer>

				<v-row class="container--fluid ma-0 px-4" align="center">
					<v-row class="ma-0" justify="end">
						<botao-primario
							outlined
							dark
							cor-de-fundo="white"
							v-if="exibirAcaoProximo"
							id="botaoProximo"
							nome-botao="Próximo"
							:disabled="desabilitarBotaoProximo"
							@click="tratarEventoProximoPasso"
						></botao-primario>
						<tooltip-informacao
							v-if="desabilitarBotaoProximo"
							class="ml-1"
							mensagem="É necessário assinar o documento para prosseguir para a próxima etapa!"
							color="white"
						></tooltip-informacao>
					</v-row>
				</v-row>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content
					v-for="passo in passos"
					:key="`${passo.numero}-content`"
					class="pa-0"
					:step="passo.numero"
				></v-stepper-content>
				<v-card height="100%">
					<router-view
						:passo-edicao-finalizado="passoRedigirTermoEstaCompleto"
						:passo-assinatura-finalizado="passoAssinaturaTermoEstaCompleto"
						:passo-juntada-finalizado="passoJuntadaTermoEstaCompleto"
						:primeira-pagina="documentoAhDesentranhar.primeiraPagina"
						:ultima-pagina="documentoAhDesentranhar.ultimaPagina"
						:titulo-documento="documentoAhDesentranhar.titulo"
						:titulo-termo="termoDesentranhamento.titulo"
						:url-acesso-documento="urlAcessoDocumento"
						@assinar-termo="tratarEventoAssinarTermo"
						@juntar-termo="tratarEventoJuntarTermo"
						@voltar="tratarEventoVoltar"
					></router-view>
				</v-card>
			</v-stepper-items>
		</v-stepper>
	</v-dialog>
</template>
<script>
import { actionTypes, routesNames, situacoes } from '@/core/constants'
import opcaoSimNao from '@/core/constants/opcaoSimNao'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-desentranhamento',
	components: { ModalConfirmacao, BotaoPrimario },
	data() {
		return {
			exibirModalDesentranhamento: true,
			passoAtual: {},
			idTermo: null,
			documentoAhDesentranhar: {},
			termoDesentranhamento: {},
			exibirModalConfirmacao: false,
			tituloModal: '',
			mensagemConfirmacaoModal: '',
			cancelarAcaoModal: null,
			confirmarAcaoModal: null,
			urlAcessoDocumento: '',
			passos: [
				{
					titulo: 'Redigir',
					rota: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_REDIGIR_TERMO_DESENTRANHAMENTO,
					desabilitado: true,
					completo: false,
					numero: 1,
				},
				{
					titulo: 'Assinar',
					rota: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_ASSINAR_TERMO_DESENTRANHAMENTO,
					desabilitado: true,
					completo: false,
					numero: 2,
				},
				{
					titulo: 'Juntar',
					rota: routesNames.ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.PROCESSO_JUNTAR_TERMO_DESENTRANHAMENTO,
					desabilitado: true,
					completo: false,
					numero: 3,
				},
			],
		}
	},
	computed: {
		desabilitarBotaoProximo() {
			return this.passoAtual.numero === 2 && !this.passoAssinaturaTermoEstaCompleto
		},
		exibirAcaoProximo() {
			return this.passoAtual.numero < this.passos[2].numero
		},
		passoRedigirTermoEstaCompleto() {
			return (
				this.ehDocumentoEmRascunho(this.termoDesentranhamento) ||
				this.ehDocumentoJuntado(this.termoDesentranhamento)
			)
		},
		passoAssinaturaTermoEstaCompleto() {
			return this.ehDocumentoAssinado(this.termoDesentranhamento)
		},
		passoJuntadaTermoEstaCompleto() {
			return this.ehDocumentoJuntado(this.termoDesentranhamento)
		},
	},
	watch: {
		$route() {
			this.tratarPassoAtual(this.$route)
		},
	},
	async created() {
		try {
			this.setIdTermo()
			await this.buscarTermoDesentranhamento()
			await this.buscarDocumentoAhDesentranhar()
			this.tratarPassoAtual(this.$route)
		} catch (e) {
			this.mostrarNotificacaoErro(e.message)
			await this.$router.push({
				name: routesNames.ATA.ATA_ACESSAR_DOCUMENTOS_VIEW,
				params: { id: this.$route.params.idAta },
			})
		}
	},
	destroyed() {
		sessionStorage.removeItem('jwt')
		sessionStorage.removeItem('redirect')
	},
	methods: {
		async buscarDocumentoAhDesentranhar() {
			if (this.ehDocumentoJuntado(this.termoDesentranhamento)) {
				return
			}
			this.documentoAhDesentranhar = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.BUSCAR_DOCUMENTO_POR_ID,
				this.termoDesentranhamento.idReferenciaDesentranhado,
			)

			this.tratarSituacaoDocumentoAhDesentranhar()
		},
		async buscarTermoDesentranhamento() {
			this.termoDesentranhamento = await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.BUSCAR_POR_ID,
				this.idTermo,
			)

			this.urlAcessoDocumento = this.termoDesentranhamento.urlEdicao
				? await this.termoDesentranhamento.urlEdicao
				: this.termoDesentranhamento.urlVisualizacao
			this.tratarTermoDesentranhamento()
		},
		async tratarEventoPassoSelecionado(passo) {
			if (passo.rota === this.$route.name) {
				return
			}
			if (passo.desabilitado) {
				return
			}

			await this.$router.replace({ name: passo.rota })
		},
		cancelarAcaoConfirmacaoFinalizacaoEdicaoTermo() {
			this.exibirModalConfirmacao = false
			this.confirmarAcaoModal = null
			this.cancelarAcaoModal = null
		},
		completarPasso1() {
			if (this.passoRedigirTermoEstaCompleto) {
				this.passos[0].desabilitado = false
				this.passos[0].completo = true
			}
		},
		completarPasso2() {
			if (this.passoAssinaturaTermoEstaCompleto) {
				this.passos[1].desabilitado = false
				this.passos[1].completo = true
			}
		},
		completarPasso3() {
			if (this.passoJuntadaTermoEstaCompleto) {
				this.passos[2].desabilitado = false
				this.passos[2].completo = true
			}
		},
		ehDocumentoAssinado(documento) {
			return documento.assinado
		},
		ehDocumentoEmRascunho(documento) {
			return documento.situacao === situacoes.DOCUMENTO.RASCUNHO.value
		},
		ehDocumentoJuntado(documento) {
			return documento.situacao === situacoes.DOCUMENTO.JUNTADO.value
		},
		ehTermoDeDesentranhamento(documento) {
			return documento.ehTermoDesentranhamento === opcaoSimNao.SIM.value
		},
		async redirecionarParaPasso1() {
			await this.$router.replace({ name: this.passos[0].rota })
		},
		async redirecionarParaPasso2() {
			await this.$router.replace({ name: this.passos[1].rota })
		},
		async redirecionarParaPasso3() {
			await this.$router.replace({ name: this.passos[2].rota })
		},
		async sincronizarTermoNoProcessoDigital() {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.DOCUMENTOS.EDITOR_TEXTO.SINCRONIZAR,
				this.termoDesentranhamento.idAssociacao,
			)
			this.mostrarNotificacaoSucesso('O termo está disponível como rascunho no processo digital')
		},
		setIdTermo() {
			this.idTermo = this.$route.params.idTermo
		},
		setPassoAtual(passo) {
			this.passoAtual = passo
		},
		setPassoDaRotaAtual(rota) {
			this.passoAtual = this.passos.find((passo) => passo.rota === rota.name)
		},
		setTodosPassosCompletos() {
			this.completarPasso1()
			this.completarPasso2()
			this.completarPasso3()
		},
		async tratarEventoAssinarTermo() {
			this.mostrarNotificacaoSucesso('Termo assinado com sucesso')
			await this.buscarTermoDesentranhamento()
			this.completarPasso2()
			await this.redirecionarParaPasso3()
		},
		tratarEventoCancelarAcaoModal() {
			this.cancelarAcaoModal()
		},
		async tratarEventoConfirmarAcaoModal() {
			await this.confirmarAcaoModal()
		},
		tratarConfirmacaoFinalizacaoEdicaoTermo() {
			this.tituloModal = 'Deseja finalizar o termo de desentranhamento?'
			this.mensagemConfirmacaoModal = `Após confirmação não será possível redigi-lo novamente, ficando disponível apenas para visualização.
				Na etapa de juntar, "${this.documentoAhDesentranhar.titulo}" poderá ser desentranhado e
				assim o respectivo termo irá substituir às pgs. ${this.documentoAhDesentranhar.primeiraPagina} a ${this.documentoAhDesentranhar.ultimaPagina}.`
			this.exibirModalConfirmacao = true
			this.confirmarAcaoModal = this.tratarPassoConfirmarFinalizacaoEdicaoTermo
			this.cancelarAcaoModal = this.cancelarAcaoConfirmacaoFinalizacaoEdicaoTermo
		},
		tratarSituacaoDocumentoAhDesentranhar() {
			if (this.ehDocumentoJuntado(this.documentoAhDesentranhar)) {
				return
			}
			throw new Error('Documento do processo digital informado para desentranhamento não está juntado!')
		},
		async tratarEventoJuntarTermo() {
			await this.$store.dispatch(
				actionTypes.ATA.DOCUMENTOS_ATA.PROCESSO_DIGITAL.DESENTRANHAMENTO.JUNTAR_TERMO,
				this.idTermo,
			)
			this.mostrarNotificacaoSucesso('Termo juntado com sucesso')
			await this.buscarTermoDesentranhamento()
			this.completarPasso3()
			this.documentoAhDesentranhar = {}
		},

		async tratarPassoConfirmarFinalizacaoEdicaoTermo() {
			await this.sincronizarTermoNoProcessoDigital()
			await this.buscarTermoDesentranhamento()
			this.completarPasso1()
			await this.redirecionarParaPasso2()
			this.exibirModalConfirmacao = false
			this.confirmarAcaoModal = null
			this.cancelarAcaoModal = null
		},
		async tratarEventoProximoPasso() {
			if (this.passoAtual.numero === 1 && !this.passoRedigirTermoEstaCompleto) {
				this.tratarConfirmacaoFinalizacaoEdicaoTermo()
				return
			}
			if (this.passoAtual.numero === 1) {
				await this.redirecionarParaPasso2()
				return
			}
			if (this.passoAtual.numero === 2 && this.passoAssinaturaTermoEstaCompleto) {
				await this.redirecionarParaPasso3()
			}
		},
		tratarEventoVoltar() {
			let idAta = this.$route.params.idAta
			this.$router.replace({
				name: routesNames.ATA.ATA_ACESSAR_DOCUMENTOS_VIEW,
				params: { id: idAta },
			})
		},
		tratarPassoAtual(rota) {
			if (
				!this.passoRedigirTermoEstaCompleto &&
				(rota.name === this.passos[1].rota || rota.name === this.passos[2].rota)
			) {
				this.passos[0].desabilitado = false
				this.passos[1].desabilitado = true
				this.passos[1].completo = false
				this.passos[2].desabilitado = true
				this.passos[2].completo = false
				this.setPassoAtual(this.passos[0])
				this.redirecionarParaPasso1()
				return
			}
			if (!this.passoAssinaturaTermoEstaCompleto && rota.name === this.passos[2].rota) {
				this.passos[0].desabilitado = false
				this.passos[0].completo = true
				this.passos[1].desabilitado = false
				this.passos[1].completo = false
				this.passos[2].desabilitado = true
				this.passos[2].completo = false
				this.setPassoAtual(this.passos[1])
				this.redirecionarParaPasso2()
				return
			}
			if (!this.passoJuntadaTermoEstaCompleto && rota.name === this.passos[2].rota) {
				this.passos[0].desabilitado = false
				this.passos[0].completo = true
				this.passos[1].desabilitado = false
				this.passos[1].completo = true
				this.passos[2].desabilitado = false
				this.passos[2].completo = false
				this.setPassoAtual(this.passos[2])
				return
			}
			if (this.passoRedigirTermoEstaCompleto) {
				this.passos[1].desabilitado = false
			}
			if (this.passoRedigirTermoEstaCompleto && this.passoAssinaturaTermoEstaCompleto) {
				this.passos[2].desabilitado = false
			}
			this.setTodosPassosCompletos()
			this.setPassoDaRotaAtual(this.$route)
		},
		tratarTermoDesentranhamento() {
			if (!this.ehTermoDeDesentranhamento(this.termoDesentranhamento)) {
				throw new Error('Termo de desentranhamento informado não é um termo válido!')
			}
		},
	},
}
</script>
